import { render, staticRenderFns } from "./QuestionOnly.vue?vue&type=template&id=71f5c27c&"
import script from "./QuestionOnly.vue?vue&type=script&lang=js&"
export * from "./QuestionOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports